import React from 'react';
import './Pages.css';

const Refund: React.FC = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Refund Policy</h1>
      </div>
      
      <div className="page-content">
        <p className="last-updated">Last updated: January 2024</p>

        <section className="content-section">
          <h2>Our Commitment</h2>
          <p>
            At GET AI PORTRAIT, we want you to be completely satisfied with your purchase. 
            We offer a straightforward refund policy to ensure your peace of mind.
          </p>
        </section>

        <section className="content-section">
          <h2>7-Day Satisfaction Guarantee</h2>
          <p>
            If you're not satisfied with your AI portraits, you can request a full refund within 
            7 days of purchase. No questions asked.
          </p>
        </section>

        <section className="content-section">
          <h2>Eligibility for Refunds</h2>
          <ul>
            <li>Purchase made within the last 7 days</li>
            <li>First-time refund request for your account</li>
            <li>Valid reason provided (optional but helpful for us to improve)</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>How to Request a Refund</h2>
          <ol>
            <li>Email us at <a href="mailto:info@dreif-ai.com">info@dreif-ai.com</a></li>
            <li>Include your order number or email used for purchase</li>
            <li>Briefly explain why you're requesting a refund (optional)</li>
            <li>We'll process your refund within 3-5 business days</li>
          </ol>
        </section>

        <section className="content-section">
          <h2>Processing Time</h2>
          <p>
            Once approved, refunds are processed within 3-5 business days. The refund will be 
            credited to your original payment method. Depending on your bank or credit card company, 
            it may take an additional 2-10 business days for the refund to appear in your account.
          </p>
        </section>

        <section className="content-section">
          <h2>Non-Refundable Items</h2>
          <p>
            Style pack purchases and subscription renewals after the first billing cycle are 
            generally non-refundable unless there's a technical issue preventing access to the service.
          </p>
        </section>

        <section className="content-section">
          <h2>Contact Us</h2>
          <p>
            For refund requests or questions about our policy:<br/>
            Email: <a href="mailto:info@dreif-ai.com">info@dreif-ai.com</a><br/>
            Please include "Refund Request" in the subject line for faster processing.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Refund;